<template>
  <div :class="[b(), className]" :style="styleSizeName">
    <div :ref="id" :style="styleChartName">
      <div class="area-select">
        <div class="select-icon" @click="handleShowList">
          <img
              style="width: 100%; height: 100%; display: block"
              :src="areaIcon"
              alt=""
          />
        </div>
        <div class="select-list" v-show="showList">
          <div class="select-content">
            <zk-tree
                class="select-tree"
                :data="areaData"
                :default-expand-all="true"
                :render-after-expand="true"
                @handleNodeClick="handleClick"
                :draggable="false"
                :allow-drag="() => false"
                :allow-drop="() => false"
                isReadonlyTree
                :props="{
                label: labelName,
              }"
                nodeKey="code"
            ></zk-tree>
          </div>
        </div>
      </div>
      <ChartNav @multiDrill="multiDrill" :currentDrillRouteIndex="currentDrillRouteIndex" @multiJump="multiJump"
              :multiActionsParam="multiActionsParam" v-model="drillIndex" :prop='prop'
              :option="option"
              :drillClickList="drillClickList"
              :drillDimList="drillDimList"></ChartNav>
    </div>
  </div>
</template>

<script>
import bgImg from "@/assets/img/list_bg.png";
import areaIcon from "@/assets/img/all_area_icon.png";
import {getOrganizationList} from "@/api/map";

export default {
  name: "allAreaSelect",
  components: {},
  props: {},
  data() {
    return {
      value: "",
      bgImg: bgImg,
      showList: false,
      labelName: 'name',
      areaData: [],
    };
  },
  computed: {
    areaIcon() {
      return this.option.componentIcon || areaIcon
    },
  },
  watch: {},
  created() {
  },
  mounted() {
  },
  destroyed() {
  },
  methods: {
    initData() {
      if (this.initLoading) {
        return
      }
      this.initLoading = true
      getOrganizationList('QYGC').then(res => {
        this.initLoading = false
        this.labelName = 'abbreviation'
        let rawData = res || []
        this.areaData = this.resetAbbRawData(rawData)
      }).catch(err => {
        this.initLoading = false
      })
    },
    handleShowList() {
      this.showList = !this.showList
    },
    resetAbbRawData(list) {
      let newList = []
      newList = list.map(item => {
        if (item.children && item.children.length) {
          item.children = this.resetAbbRawData(item.children)
        }
        return {
          ...item,
          abbreviation: item.abbreviation || item.name,
        }
      })
      return newList
    },
    updateChart() {
      if (!this.isDataCenter) {
        // 避免重复触发
        if (!this.areaData.length) {
          this.initData()
        }
        return;
      }
      const {categories = [], series = []} = this.getDimentionOption();
      if (!categories.length && !series.length && !this.areaData.length) {
        this.initData()
      } else {
        this.areaData = categories.map(item => {
          return {
            code: item,
            name: item,
            abbreviation: item,
          }
        })
      }
    },
  },
};
</script>

<style lang="scss">
.area-select {
  position: relative;
}

.select-list {
  width: 270px;
  height: 360px;
  position: absolute;
  background-image: url("@/assets/img/list_bg.png");
  background-size: 100% 100%;
  top: -360px;
  left: 0px;
  padding: 32px 27px;
  box-sizing: border-box;

  .select-content {
    width: 216px;
    height: 296px;
    overflow-y: auto;

    .ks-tree {
      background-color: transparent;

      .ks-tree-title {
        display: none;
      }

      .ks-tree-search {
        margin: 0;
        width: 100%;
        height: 34px;
        border-radius: 4px;
        background: #2d5b925e;
        margin-bottom: 11px;

        .el-input__wrapper {
          background: #2d5b925e;
          box-shadow: none;
        }

        .el-input__wrapper.is-focus {
          box-shadow: none;
        }
      }

      .is-current > .el-tree-node__content .zk-toottip > .text-box {
        color: #e1faff !important;
        font-weight: 500;
      }

      .is-current > .el-tree-node__content:before {
        display: none;
      }

      .ks-tree-container {
        height: calc(100% - 50px);
        background: transparent;
        color: #bfedf7e6;

        .ks-tree-node {
          overflow: auto;

          .ks-tree-node-name {
            overflow: auto;

            .text-box {
              color: #bfedf7e6;
            }
          }
        }

        .el-tree-node__content {
          .el-tree-node__expand-icon {
            color: #0b6699;
            margin-left: 0 !important;
          }

          .is-leaf {
            width: 0;
          }
        }
      }

      .el-tree--highlight-current
      .el-tree-node.is-current
      > .el-tree-node__content {
        background: transparent;
      }

      .el-tree-node:focus > .el-tree-node__content {
        background: transparent;
      }

      .el-tree-node__content:hover {
        background: transparent;
        color: #e1faff;
        font-weight: 500;
      }
    }
  }
}
</style>
